/**
 * @desc 禁用
 */
import { ApplyAuditForm } from '@eastcoal/api/trade/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type ForbiddenAuctionApplyParameter = ApplyAuditForm

const method = 'PUT'
const url = '/trade/operation/apply/auction/forbidden'

export const forbiddenAuctionApplyApi = (
  data?: ForbiddenAuctionApplyParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<any>({
    method,
    url,
    data,
    ...config
  })
}

forbiddenAuctionApplyApi.method = method
forbiddenAuctionApplyApi.url = url
